// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ManagedSftpFilesQueryVariables = Types.Exact<{
  path: Types.Scalars['String']['input'];
}>;


export type ManagedSftpFilesQuery = { __typename?: 'Query', managedSFTPFiles: Array<{ __typename?: 'ManagedSFTPFileEntry', name: string, path: string, isDirectory: boolean, sizeBytes?: number | null, lastModified?: Time | null }> };

export const Operations = {
  Query: {
    ManagedSFTPFiles: 'ManagedSFTPFiles' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const ManagedSftpFilesDocument = gql`
    query ManagedSFTPFiles($path: String!) {
  managedSFTPFiles(path: $path) {
    name
    path
    isDirectory
    sizeBytes
    lastModified
  }
}
    `;

/**
 * __useManagedSftpFilesQuery__
 *
 * To run a query within a React component, call `useManagedSftpFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagedSftpFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedSftpFilesQuery({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */
export function useManagedSftpFilesQuery(baseOptions: Apollo.QueryHookOptions<ManagedSftpFilesQuery, ManagedSftpFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManagedSftpFilesQuery, ManagedSftpFilesQueryVariables>(ManagedSftpFilesDocument, withFetchPolicyContext(options));
      }
export function useManagedSftpFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManagedSftpFilesQuery, ManagedSftpFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManagedSftpFilesQuery, ManagedSftpFilesQueryVariables>(ManagedSftpFilesDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useManagedSftpFilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ManagedSftpFilesQuery, ManagedSftpFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ManagedSftpFilesQuery, ManagedSftpFilesQueryVariables>(ManagedSftpFilesDocument, withFetchPolicyContext(options));
        }
export type ManagedSftpFilesQueryHookResult = ReturnType<typeof useManagedSftpFilesQuery>;
export type ManagedSftpFilesLazyQueryHookResult = ReturnType<typeof useManagedSftpFilesLazyQuery>;
export type ManagedSftpFilesSuspenseQueryHookResult = ReturnType<typeof useManagedSftpFilesSuspenseQuery>;
export type ManagedSftpFilesQueryResult = Apollo.QueryResult<ManagedSftpFilesQuery, ManagedSftpFilesQueryVariables>;